<template>
<div>
    <div class="Vue-Toastification__container top-center" v-if="notifications.length">
        <div class="Vue-Toastification__toast Vue-Toastification__toast--info top-center" style="" v-for="(notification) in notifications" :key="notification.id">
            <svg aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="svg-inline--fa fa-info-circle fa-w-16 Vue-Toastification__icon">
                <path fill="currentColor" d="M256 8C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm0 110c23.196 0 42 18.804 42 42s-18.804 42-42 42-42-18.804-42-42 18.804-42 42-42zm56 254c0 6.627-5.373 12-12 12h-88c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h12v-64h-12c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h64c6.627 0 12 5.373 12 12v100h12c6.627 0 12 5.373 12 12v24z"></path>
            </svg> 
            <div role="alert" class="Vue-Toastification__toast-body">{{ notification.content }}</div> 
            <button @click="dismiss(notification)" aria-label="close" class="Vue-Toastification__close-button">×</button> 
        </div>
    </div>
</div>
</template>

<script>
    const DELIMETER = '-';

    export default {
        data() {
            return {
                notifications: [],
            }
        },
        mounted() {
            this.get();
        },
        methods: {
            get() {
                this.$root.axios.get('/api/notifications')
                .then(res => {
                    let ids = this.$cookie.get('notifications'),
                        idsArray = ids ? ids.split(DELIMETER) : false,
                        notificationsList = [];

                    if(ids && idsArray.length) {
                        res.data.forEach(function(element) {
                            if(! idsArray.includes(element.id.toString())) {
                                notificationsList.push(element);
                            }
                        });

                        this.notifications = notificationsList;
                    }

                    if(! ids) {
                        this.notifications = res.data;
                    }
                });
            },
            dismiss(notification) {
                if(! notification.user_id) {
                    let ids = this.$cookie.get('notifications');

                    if(ids) {
                        if(! ids.split(DELIMETER).includes(notification.id.toString())) {
                            let newList = ids + notification.id.toString() + DELIMETER;

                            this.$cookie.set('notifications', newList, { 
                                expires: "1Y" 
                            });  
                        }
                    }

                    if(! ids) {
                        this.$cookie.set('notifications', notification.id + DELIMETER, { 
                            expires: "1Y" 
                        });  
                    }

                    this.notifications = this.notifications.filter(object => {
                        return object.id !== notification.id;
                    });

                    return;
                }

                this.$root.axios.post('/api/notification/dismiss', {
                    id: notification.id
                })
                .then(res => {
                    this.notifications = this.notifications.filter(object => {
                        return object.id !== notification.id;
                    });
                });
            },
        },
    }
</script>